import L from 'leaflet';
import detail_dosha_map from './detail/detail_dosha_map';
import detail_uryo_map from './detail/detail_uryo_map';
import util from './util';
import detail_snake from './detail/detail_snake';
window.onload = () => {
    comMain(() => {
        setTimeout(() => {
            let detail = new uryoDetail();
            detail.Initilize();
            // 生成したインスタンスをグローバル変数に保存
            window.uryoDetailInstance = detail;
        }, 10);
    });
};
/**
 * 雨量詳細画面（４画面表示）
 */
export default class uryoDetail {
    _doshaMap = null;
    _uryoMap = null;
    _snakeGraph = null;
    _doshaMapModal = null;
    _uryoMapModal = null;
    _uryoPointTable = {};
    _doshaMapId = "detail_dosha_map";
    _doshaMapModalId = "doshaMapModal";
    _uryoMapId = "detail_uryo_map";
    _uryoMapModalId = "uryoMapModal";
    /**
     * コンストラクタ
     */
    constructor() {
    }
    /**
     * 初期化処理
     */
    Initilize() {
        const self = this;
        const uryoGeoJson = util.getGeoJson(util.getPath(dosya_1kmesh_env.uryoGeoJson));
        //  雨量計測地点テーブル作成
        this._uryoPointTable = this.createUryoPointTable(uryoGeoJson);
        //  地図の表示位置取得
        let mapPos = this.getMapPos();
        if (mapPos.mesh_code) {
            this._snakeGraph = new detail_snake(mapPos.mesh_code, true);
        }
        this._uryoMap = new detail_uryo_map(mapPos, (uryoPiont) => { self.onUryoPointClick(uryoPiont); }, false, this._uryoMapId);
        this._uryoMapModal = new detail_uryo_map(mapPos, (uryoPiont) => { self.onUryoPointClick(uryoPiont); }, false, this._uryoMapModalId);
        this._doshaMap = new detail_dosha_map(mapPos, (meshcode) => { self.onMeshClick(meshcode); }, this._doshaMapId);
        this._doshaMapModal = new detail_dosha_map(mapPos, (meshcode) => { self.onMeshClick(meshcode); }, this._doshaMapModalId);
        if (mapPos.uryo_point) {
            this._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            this._uryoMapModal.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
        }
        this._doshaMap.dispMeshLayer();
        this._doshaMapModal.dispMeshLayer();
        // メッシュのレイヤ(map_doshaのInitilize())がsetTimeout()しているので赤枠表示もsetTimeout()　※赤枠を前面にしたいだけ
        setTimeout(() => {
            if (this._doshaMap) {
                this._doshaMap.selectMesh(mapPos.mesh_code);
            }
            if (this._doshaMapModal) {
                this._doshaMapModal.selectMesh(mapPos.mesh_code);
            }
        }, 10);
        //  地図の同期表示
        this.setLinkMap();
        //  説明のツールチップ表示
        this.setUryoMapToolTip(this._uryoMapId);
        this.setUryoMapToolTip(this._uryoMapModalId);
        //  自動更新処理
        this.checkDoshaLayer();
        this.checkUryoLayer();
        this.setUpdateCheckInterval();
        // 雨量詳細画面サブスクリプト（uryoDetailSub.js）初期化
        uryoDetailSubInit(GM_ID_PC_URYO_DETAIL, mapPos.uryo_point);
    }
    /**
     * データの更新チェック処理
     */
    setUpdateCheckInterval() {
        setInterval(() => {
            this.checkDoshaLayer();
        }, config.doshaDetailDataCheckMiliSec);
        setInterval(() => {
            this.checkUryoLayer();
        }, config.uryoDetailDataCheckMiliSec);
    }
    /**
     * 土砂詳細データの更新確認
     */
    checkDoshaLayer() {
        const curUpdt = getUpdateTime(util.getPath(dosya_1kmesh_env.mesh1kUpdateTime));
        const preUpdt = oldUpdatetimes.doshaMesh1k;
        if (curUpdt && (!preUpdt || (preUpdt < curUpdt))) {
            //  更新があった場合はマップ情報、スネーク図を更新
            if (this._doshaMap) {
                this._doshaMap.checkUpdateLayer();
            }
            if (this._doshaMapModal) {
                this._doshaMapModal.checkUpdateLayer();
            }
            if (this._snakeGraph) {
                this._snakeGraph.reflash();
            }
        }
    }
    /**
     * 雨量詳細データの更新確認
     */
    checkUryoLayer() {
        //  更新時刻の取得
        getTextFile(config.updUinfoUrl, false, (updateTime) => {
            if (!oldUpdatetimes.uinfo || updateTime > oldUpdatetimes.uinfo) {
                //  更新があった場合はマップ情報、グラフを更新
                if (this._uryoMap) {
                    this._uryoMap.checkUpdateLayer(updateTime);
                }
                if (this._uryoMapModal) {
                    this._uryoMapModal.checkUpdateLayer(updateTime);
                }
            }
        });
    }
    /**
     * 説明用ツールチップのイベント設定
     */
    setUryoMapToolTip(parentId) {
        const mapElement = $(`#${parentId}`);
        const tipElement = $(`.${parentId}.detail_uryo_map_tooltip`);
        mapElement.on('mouseenter', (e) => {
            tipElement.show();
        });
        mapElement.on('mouseleave', (e) => {
            if (!tipElement.is(":hover")) {
                tipElement.hide();
                mapElement.on('mouseenter', (e) => {
                    tipElement.show();
                });
            }
        });
        // tipElementをクリックしたとき
        tipElement.on('click', (e) => {
            tipElement.hide();
            mapElement.off('mouseenter');
        });
    }
    /**
     * 地図の表示位置をリンクします
     */
    setLinkMap() {
        //  地図の同期表示処理実装
        let ownerMap = null;
        let setOwner = (le) => {
            if (ownerMap === null) {
                ownerMap = le.target;
            }
        };
        let moveend = (le) => {
            if (ownerMap && ownerMap === le.target) {
                let center = ownerMap.getCenter();
                if (this._doshaMap) {
                    if (ownerMap !== this._doshaMap.Map) {
                        this._doshaMap.Map.panTo(center);
                    }
                }
                if (this._doshaMapModal) {
                    if (ownerMap !== this._doshaMapModal.Map) {
                        this._doshaMapModal.Map.panTo(center);
                    }
                }
                if (this._uryoMap) {
                    if (ownerMap !== this._uryoMap.Map) {
                        this._uryoMap.Map.panTo(center);
                    }
                }
                if (this._uryoMapModal) {
                    if (ownerMap !== this._uryoMapModal.Map) {
                        this._uryoMapModal.Map.panTo(center);
                    }
                }
                ownerMap = null;
                if (this._doshaMap) {
                    this._doshaMap.reflash();
                }
                if (this._doshaMapModal) {
                    this._doshaMapModal.reflash();
                }
            }
        };
        if (this._doshaMap) {
            this._doshaMap.Map.on("movestart", setOwner);
            this._doshaMap.Map.on("moveend", moveend);
        }
        if (this._doshaMapModal) {
            this._doshaMapModal.Map.on("movestart", setOwner);
            this._doshaMapModal.Map.on("moveend", moveend);
        }
        if (this._uryoMap) {
            this._uryoMap.Map.on("movestart", setOwner);
            this._uryoMap.Map.on("moveend", moveend);
        }
        if (this._uryoMapModal) {
            this._uryoMapModal.Map.on("movestart", setOwner);
            this._uryoMapModal.Map.on("moveend", moveend);
        }
    }
    /**
     * 雨量計測地点クリック時
     * @param uryoPoint 雨量計測地点コード
     */
    onUryoPointClick(uryoPoint) {
        let mapPos = this.getMapPosUryoPointLatLng(uryoPoint);
        this.setView(mapPos);
    }
    /**
     * メッシュクリック時イベント
     * @param meshcode メッシュコード
     */
    onMeshClick(meshcode) {
        let mapPos = this.getMapPosByMeshCode(meshcode);
        this.setView(mapPos);
    }
    /**
     * 地図表示位置の変更
     * @param latlng
     */
    setView(mapPos) {
        //  雨量計測地点地図
        if (this._uryoMap) {
            if (mapPos.uryo_point) {
                this._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            }
            this._uryoMap.Map.setView(mapPos.center, mapPos.zoom);
        }
        if (this._uryoMapModal) {
            if (mapPos.uryo_point) {
                this._uryoMapModal.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            }
            this._uryoMapModal.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  土砂災害メッシュ
        if (this._doshaMap) {
            if (mapPos.mesh_code) {
                this._doshaMap.selectMesh(mapPos.mesh_code);
            }
            this._doshaMap.Map.setView(mapPos.center, mapPos.zoom);
        }
        if (this._doshaMapModal) {
            if (mapPos.mesh_code) {
                this._doshaMapModal.selectMesh(mapPos.mesh_code);
            }
            this._doshaMapModal.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  スネーク図
        if (this._snakeGraph && mapPos.mesh_code) {
            this._snakeGraph.dispGraph(mapPos.mesh_code);
        }
        // // 雨量詳細画面サブスクリプト（uryoDetailSub.js）に通知
        if (mapPos.uryo_point) {
            onChageUryoPoint(mapPos.uryo_point);
        }
    }
    /**
     * メッシュコードから地図表示情報の取得
     * @param meshcode
     */
    getMapPosByMeshCode(meshcode) {
        let latlng = util.meshToLatLng(meshcode);
        return {
            center: latlng,
            zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            mesh_code: meshcode,
            uryo_point: this.getNearestUryoPoint(latlng),
        };
    }
    /**
     * 雨量計測地点から、地図表示情報を取得
     * @param uryoPoint
     */
    getMapPosUryoPointLatLng(uryoPoint) {
        let latlng = this.getUryoPointLatLng(uryoPoint);
        return {
            center: latlng,
            zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            mesh_code: util.latlngToMesh(latlng),
            uryo_point: uryoPoint,
        };
    }
    /**
     *
     */
    getMapPos() {
        let mesh = util.getUrlVars('mesh'); //  引数のメッシュコード
        let uryoPoint = util.getUrlVars('ccd'); //  引数の雨量計測地点
        if (mesh) {
            return this.getMapPosByMeshCode(mesh);
        }
        else if (uryoPoint) {
            return this.getMapPosUryoPointLatLng(uryoPoint);
        }
        else {
            //  メッシュコードまたは雨量計測地点が指定されていない場合、エラーとする
            alert(dosya_1kmesh_env.message.error.noPoint);
            return {
                center: config.initMapLatLon,
                zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
                minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
                maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            };
        }
    }
    /**
     * 雨量計測地点テーブルの生成
     * @param geoJson
     */
    createUryoPointTable(geoJson) {
        let result = {};
        geoJson.features.forEach((f) => {
            let prop = f.properties;
            let geo = f.geometry;
            if (prop && geo) {
                if (geo.coordinates.length >= 2) {
                    let lng = geo.coordinates[0];
                    let lat = geo.coordinates[1];
                    result[prop.code] = new L.LatLng(lat, lng);
                }
            }
        });
        return result;
    }
    /**
     * 雨量ポイントの経緯度を取得
     */
    getUryoPointLatLng(uryoPoint) {
        if (this._uryoPointTable) {
            if (this._uryoPointTable[uryoPoint]) {
                return this._uryoPointTable[uryoPoint];
            }
        }
        alert(dosya_1kmesh_env.message.error.uryoNoPosition);
        return config.initMapLatLon;
    }
    /**
     * 最寄りの雨量計測地点を取得
     * @param latLng
     */
    getNearestUryoPoint(latLng) {
        let neerDistance = Number.MAX_VALUE;
        let neerPoint = '';
        for (let key in this._uryoPointTable) {
            let uryoPointLatLng = this._uryoPointTable[key];
            let distance = util.getDistance(latLng, uryoPointLatLng);
            if (neerDistance > distance) {
                neerDistance = distance;
                neerPoint = key;
            }
        }
        ;
        return neerPoint;
    }
    /**
     * 外部からの60分10分切替用関数
     */
    onChange60min10min(is60min) {
        if (this._uryoMap) {
            this._uryoMap.onChange60min10min(is60min);
        }
        if (this._uryoMapModal) {
            this._uryoMapModal.onChange60min10min(is60min);
        }
    }
}
